"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sessionHasChanged = void 0;
/**
 * Compares a session with a cached session and returns true if the session has changed
 * @param session The session to compare
 * @param cachedSession The cached session to compare against
 * @returns true if the session has changed, false otherwise
 */
const sessionHasChanged = (session, cachedSession) => {
    // Error is an optional string so we check that first
    if (session.error !== cachedSession.error) {
        return true;
    }
    return Object.entries(session).some(([key, value]) => {
        if (key === 'hasScopes') {
            return false;
        }
        if (key === 'user') {
            // If both users don't exist, they haven't changed
            if (!value && !cachedSession.user) {
                return false;
            }
            // If one user exists and the other doesn't, they have changed
            if (!value || !cachedSession.user) {
                return true;
            }
            return Object.entries(value).some(([userKey, userValue]) => {
                if (userKey === 'roles') {
                    return (userValue.length !==
                        cachedSession.user.roles.length ||
                        userValue.some((role, i) => role !== cachedSession.user.roles[i]));
                }
                return (userValue !== cachedSession.user[userKey]);
            });
        }
        return value !== cachedSession[key];
    });
};
exports.sessionHasChanged = sessionHasChanged;
